import React, { FC, useContext, useMemo } from 'react';
import styles from './index.module.scss';
import { Progress, Spin } from 'antd';
import { Empty } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { apiV2PaintingDashboardOverviewPost } from '@maxtropy/device-customer-apis-v2';
import { keepOneAndWanOrLine, keepOneOrLine } from '@/utils/utils';
import { DateContext } from '../../../index';
import { IndexTimeActive } from '../../SwitchDate';
import iconDeviceEnergy from '../../../imgs/icon_device_energy.png';
import iconPlaceholder from '../../../imgs/icon_placeholder.png';
import bannerHeader from '../../../imgs/banner_header.png';

const HighEnergyDevice: FC = () => {
  const { activeKey, selectedDate } = useContext(DateContext);

  // 构建请求参数
  const requestParams = useMemo(() => {
    const timeResolution = activeKey === IndexTimeActive.THIS_MONTH ? 'M' : 'Y';
    const unit = activeKey === IndexTimeActive.THIS_MONTH ? 'month' : 'year';
    const startTime = selectedDate.startOf(unit).valueOf();
    // 结束时间：前一天23:59:59（如果是当前月份/年份），否则为月末/年末
    const isCurrentPeriod =
      selectedDate.format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY') ===
      dayjs().format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY');
    const endTime = isCurrentPeriod
      ? dayjs().subtract(1, 'day').endOf('day').valueOf()
      : selectedDate.endOf(unit).valueOf();
    return { startTime, endTime, timeResolution };
  }, [activeKey, selectedDate]);

  const { data, loading } = useRequest(() => apiV2PaintingDashboardOverviewPost(requestParams), {
    refreshDeps: [requestParams],
  });

  const energyData = useMemo(() => {
    if (!data) return null;
    return {
      electricityUsage: keepOneAndWanOrLine(data.totalHighEnergyConsumption),
      ratio: keepOneOrLine(data.ratio),
      ratioNum: data.ratio ?? 0,
    };
  }, [data]);

  if (loading) {
    return (
      <div className={styles.loading_wrapper}>
        <Spin />
      </div>
    );
  }

  if (!energyData) {
    return <Empty />;
  }

  return (
    <div className={styles.device_energy_card}>
      <div className={styles.device_energy_top} style={{ backgroundImage: `url(${bannerHeader})` }}>
        <div className={styles.device_energy_left}>
          <div className={styles.device_icon_wrapper}>
            <div className={styles.device_icon_ring}>
              <img className={styles.device_icon} src={iconDeviceEnergy} alt="高能耗设备" />
            </div>
            <img className={styles.device_icon_placeholder} src={iconPlaceholder} alt="" />
          </div>
          <div className={styles.device_info}>
            <div className={styles.device_label}>高能耗设备用电量(kWh)</div>
            <div className={styles.device_value}>{energyData.electricityUsage}</div>
          </div>
        </div>
        <div className={styles.device_energy_right}>
          <div className={styles.ratio_header}>
            <span className={styles.ratio_label}>占涂装总用电量：</span>
            <span className={styles.ratio_value}>{energyData.ratio}%</span>
          </div>
          <Progress
            percent={energyData.ratioNum}
            showInfo={false}
            strokeColor="#16DD8E"
            trailColor="rgba(45, 141, 226, 0.2)"
            size={[200, 8]}
          />
        </div>
      </div>
    </div>
  );
};

export default HighEnergyDevice;
